import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  TextField,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { DatePicker } from '@material-ui/pickers';
import Moment from 'moment'

const useStyles = makeStyles(theme => ({
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  resetButton: {
    flex: 1,
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  buttonsContainer: {
    marginTop: 10,
  },
}))

const DateRange = props => {
  const { values, setValues, label, } = props;

  const classes = useStyles();
  const [calendarTrigger, setCalendarTrigger] = useState(null);

  const handleCalendarOpen = trigger => {
    setCalendarTrigger(trigger);
  };

  const handleCalendarClose = () => {
    setCalendarTrigger(false);
  };

  const handleCalendarAccept = date => {
    setValues(label, { [calendarTrigger]: date })
  };

  const handleCalendarChange = () => {};

  const resetDate = (trigger) => {
    setValues(label, { [trigger]: '' })
  }

  const calendarOpen = Boolean(calendarTrigger);
  const calendarMinDate = Moment().subtract(100, 'years');
  const calendarValue = values[calendarTrigger];

  return (
    <div className={classes.fieldGroup}>
      <TextField
        className={classes.dateField}
        label="From"
        name="startDate"
        onClick={() => handleCalendarOpen('startDate')}
        value={values.startDate ? Moment(values.startDate).format('DD/MM/YYYY') : ''}
        variant="outlined"
        InputProps={values.startDate ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="reset the date"
                onClick={(e) => { e.stopPropagation(); resetDate('startDate') }}
              >
                <CloseIcon/>
              </IconButton>
            </InputAdornment>
          ),
        } : null}
      />
      <TextField
        className={classes.dateField}
        label="To"
        name="endDate"
        onClick={() => handleCalendarOpen('endDate')}
        value={values.endDate ? Moment(values.endDate).format('DD/MM/YYYY') : ''}
        variant="outlined"
        InputProps={values.endDate ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="reset the date"
                onClick={(e) => { e.stopPropagation(); resetDate('endDate') }}
              >
                <CloseIcon/>
              </IconButton>
            </InputAdornment>
          ),
        } : null}
      />
      <DatePicker
        minDate={calendarMinDate}
        onAccept={handleCalendarAccept}
        onChange={handleCalendarChange}
        onClose={handleCalendarClose}
        open={calendarOpen}
        style={{ display: 'none' }}
        value={calendarValue}
        variant="dialog"
      />
    </div>
  )
}

DateRange.propTypes = {
  values: PropTypes.object,
};

export default DateRange;
